export const STATUS_LIST = [
  "RECEIVED",
  "IN_DIAGNOSIS",
  "WAITING_APPROVAL",
  "WAITING_PARTS",
  "IN_REPAIR",
  "TESTING",
  "REPAIRED",
  "READY",
  "DELIVERED",
  "NOT_REPAIRABLE",
  "CLIENT_REJECTED",
  "IN_WARRANTY",
];

export const STATUS_LABEL = {
  RECEIVED: "Recibido",
  IN_DIAGNOSIS: "En diagnóstico",
  WAITING_APPROVAL: "Esperando aprobación",
  WAITING_PARTS: "Esperando repuesto",
  IN_REPAIR: "En reparación",
  TESTING: "En pruebas",
  REPAIRED: "Reparado",
  READY: "Listo para retirar",
  DELIVERED: "Retirado por cliente",
  NOT_REPAIRABLE: "No reparable",
  CLIENT_REJECTED: "Cliente rechazó reparación",
  IN_WARRANTY: "En garantía",
};

export const STATUS_STYLES = {
  RECEIVED: "bg-sky-100 text-sky-700 border-sky-200",
  IN_DIAGNOSIS: "bg-amber-100 text-amber-700 border-amber-200",
  WAITING_APPROVAL: "bg-amber-100 text-amber-700 border-amber-200",
  WAITING_PARTS: "bg-amber-100 text-amber-700 border-amber-200",
  IN_REPAIR: "bg-amber-100 text-amber-700 border-amber-200",
  TESTING: "bg-blue-100 text-blue-700 border-blue-200",
  REPAIRED: "bg-green-100 text-green-700 border-green-200",
  READY: "bg-green-100 text-green-700 border-green-200",
  DELIVERED: "bg-slate-100 text-slate-600 border-slate-200",
  NOT_REPAIRABLE: "bg-red-100 text-red-700 border-red-200",
  CLIENT_REJECTED: "bg-red-100 text-red-700 border-red-200",
  IN_WARRANTY: "bg-indigo-100 text-indigo-700 border-indigo-200",
};

export const PHOTO_CATEGORIES = [
  { key: "BEFORE", label: "Antes" },
  { key: "DIAGNOSIS", label: "Diagnóstico" },
  { key: "DURING", label: "Reparación" },
  { key: "AFTER", label: "Reparado / Finalizado" },
  { key: "DELIVERY", label: "Entrega" },
  { key: "OTHER", label: "Otras" },
];

// Etapas cronológicas del flujo de reparación técnica (sin Entrega, que
// pertenece al proceso posterior de retiro/entrega al cliente).
export const REPAIR_STAGES = [
  { key: "BEFORE", label: "Antes", description: "Estado del equipo al recibirlo" },
  { key: "DURING", label: "Reparación", description: "Proceso de trabajo" },
  { key: "AFTER", label: "Finalización", description: "Cierre de la reparación" },
];

export const ROLE_LABEL = {
  admin: "Administrador",
  supervisor: "Supervisora",
  technician: "Técnico",
  reception: "Recepción / Vendedor",
};

export function canCreateOrder(role) {
  return ["admin", "supervisor", "reception", "technician"].includes(role);
}
export function canEditOrderFull(role) {
  return ["admin", "supervisor"].includes(role);
}
export function canManageUsers(role) {
  return role === "admin";
}
export function canManageBranches(role) {
  return role === "admin";
}
export function canManageCategories(role) {
  return role === "admin";
}
export function canDeletePhoto(role) {
  // El técnico puede eliminar fotos (ej.: subida accidental) en cualquier etapa.
  return ["admin", "supervisor", "technician"].includes(role);
}
